import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const initialPath = window.location.pathname.replace(/\/+$/, "") || "/";

export function cleanupPrerenderOnNavigation(startPath, currentPath) {
  if ((currentPath.replace(/\/+$/, "") || "/") === startPath) return;
  document.getElementById("homepage-prerender")?.remove();
  document.getElementById("public-page-prerender")?.remove();
}

export default function usePrerenderCleanup() {
  const { pathname } = useLocation();
  useEffect(() => cleanupPrerenderOnNavigation(initialPath, pathname), [pathname]);
}
